/**
 * @generated SignedSource<<1034ea163b3cae928e3eb01acbdefca8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedPixCreditCard_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGraphQLType_query">;
  readonly " $fragmentType": "PaymentLinkCompletedPixCreditCard_query";
};
export type PaymentLinkCompletedPixCreditCard_query$key = {
  readonly " $data"?: PaymentLinkCompletedPixCreditCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedPixCreditCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedPixCreditCard_query",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useGraphQLType_query",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "graphqlType",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1d62bf7b0f341d587395b1c081a63894";

export default node;
